import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box, Grid } from "@mui/material";
import KeyboardArrowLeftRoundedIcon from "@mui/icons-material/KeyboardArrowLeftRounded";
import polyline from "polyline";
import { debounce } from "lodash";
import useModal from "hooks/useModal";
import {
  addBooking,
  updateBooking,
  clearBookingDetails,
  getBookingDetails,
  getBookingBufferTime,
  getCompanyService,
  getAirportTerminalList,
} from "redux/actions/ReservationAction";
import {
  getEmployeesList,
} from "redux/actions/EmployeesAction";
import {
  clearAutoComplete,
  getAutoComplete,
  getDirection,
  getGeocode,
  getPlaceDetails,
} from "redux/actions/UserGoogleMap";
import { fetchCompanyDetails } from "redux/actions/companyAction";
import { clearRateCard, getRateCard } from "redux/actions/UserRateCard";
import { getRateCalculation } from "redux/actions/UserRateCalculation";
import { getCar, getCarFacilities } from "redux/actions/UserCar";
import { getDateFormat, optionsList } from "utils/utils";
import { tripDutyTypeEnum } from "utils/enumObj";
import CommonButton from "components/commonButton/CommonButton";
import CommonMultiForm from "components/commonMultiForm/CommonMultiForm";
import ConfirmModal from "components/confirmModal/ConfirmModal";
import Loader from "components/loader/Loader";
import { bookingByForm, bookingForm } from "./FrontDeskData";
import { getCountryCode } from "redux/actions/authAction";
import { requestExtensionService } from "services/ReservationService";
import { toast, ToastContainer } from 'react-toastify';
import dayjs from 'dayjs';

const FrontDeskNewBooking = () => {
  const [isDisabled, setisDisabled] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const editStatus = location?.state?.page;
  const { open, toggle } = useModal();

  const [currentLat, setCurrentLat] = useState("");
  const [currentLong, setCurrentLong] = useState("");
  const [defaultLocation, setDefaultLocation] = useState({});

  const [pickupAndDropAddress, setPickupAndDropAddress] = useState({ pickup: '', landMark: '', drop: '' });
  const [decodedPoints, setDecodedPoints] = useState();
  const [dutyTypeLabel, setDutyTypeLabel] = useState("");
  const [pickupLat, setPickupLat] = useState('');
  const [pickupLong, setPickupLong] = useState('');

  const bookingBufferTime = useSelector(
    (state) => state?.getBookingBufferTime?.bufferTime?.data
  );

  const bookingDetails = useSelector(
    (state) => state?.getBookingDetails?.bookingDetails
  );
  const details = optionsList(bookingDetails);
  const employeeList = useSelector(
    (state) => state?.getEmployeesList?.employeesList?.data?.body
  );
  const selectedCompanyDetails = useSelector(
    (state) => state?.userCompanyDetails?.companyDetails
  );
  const companyCityList = useSelector(
    (state) => state?.getCompanyCity?.companyCity?.data
  );
  const companyServiceList = useSelector(
    (state) => state?.getCompanyService?.companyService?.data
  );
  const carList = useSelector((state) => state?.userCar?.userCar?.data);
  const companyEmployeelist =
    employeeList &&
    employeeList?.map((val, idx) => {
      return { value: val?.email, label: val?.email, id: val?.id };
    });

  const companyProfileBooking =
    selectedCompanyDetails?.Contracts?.[0]?.ContractDetails;
  const rateCard = useSelector(
    (state) => state?.userRateCard?.userRateCard?.data
  );

  const airportTerminalList = useSelector((state) => state?.getAirportTerminalList?.airportTerminalList?.data);

  const airportTerminalOption = airportTerminalList?.body && airportTerminalList?.body?.map((val) => {
    return { value: val?.id, label: `${val.terminal} ${val?.name}`, place_id: val.placeId };
  })

  const companyCarList =
    companyProfileBooking &&
    companyProfileBooking.filter((obj) => obj.type === "vehicle");
  const editDutyOption = [
    {
      value: bookingDetails?.type,
      label: bookingDetails?.dutyTypeName,
      id: bookingDetails?.type,
    },
  ];
  const dutyTypeOption = editStatus
    ? editDutyOption
    : companyServiceList?.map((val) => {
      return {
        value: val?.id,
        label: val?.name,
        tripType: val?.tripType,
      };
    });
  const editCarOption = [
    {
      value: bookingDetails?.carTypeId,
      label: bookingDetails?.carType,
      id: bookingDetails?.carTypeId,
    },
  ];
  const carOption = editStatus
    ? editCarOption
    : carList?.length &&
    carList?.map((val) => {
      return { value: val?.id, label: val?.carType, seater: val?.seater };
    });
  const companyCarOptions = companyCarList?.map((val) => {
    return { value: val?.vehicle?.id, label: val?.vehicle?.carType };
  });
  const cityOption = companyCityList?.map((val) => {
    return { value: val?.id, label: val?.name, geoPoint: val?.geoPoint };
  });
  const branchOption = selectedCompanyDetails?.branch?.map((val) => {
    return { value: val?.id, label: val?.address };
  });

  const rateCardPackage = rateCard?.length > 0 ? rateCard.map((val) => {
    return {
      value: val?.id,
      label: val?.rateConfig?.name
    }
  }) : []

  const userProfile = useSelector((state) => state?.userProfile?.profileDetails?.data);

  const currentLocationData =
    useSelector((state) => state.userGeocode?.userGeocode?.results) || [];

  const pickUpLatLngData = useSelector(
    (state) =>
      state?.userPlaceDetails?.pickup?.pickup?.data?.result?.geometry?.location
  );

  const role = localStorage.getItem("role");
  const companyID = localStorage.getItem("subCompany")?.length > 0 && JSON.parse(localStorage.getItem("subCompany"));

  const employeelist = [
    { value: userProfile?.email, label: userProfile?.email, id: userProfile?.id }
  ];


  const landMarkLatLngData = useSelector(
    (state) =>
      state?.userPlaceDetails?.landMark?.landMark?.data?.result?.geometry?.location
  );

  const [rateCardDetails, setRateCardDetails] = useState({
    dutyTypeId: "",
    vehicleCategoryId: "",
    location: "",
    locationName: ""
  });
  const extensionMode = location?.state?.page === "extension";

  

  const dropLatLngData = useSelector(
    (state) =>
      state?.userPlaceDetails?.drop?.drop?.data?.result?.geometry?.location
  );
  const directionDataPoints = useSelector(
    (state) => state?.userDirection?.userDirection?.data?.routes?.[0]?.legs?.[0]
  );
  const overviewPolyline = useSelector(
    (state) =>
      state?.userDirection?.userDirection?.data?.routes?.[0]?.overview_polyline
        ?.points
  );

  const companyLoader = useSelector(
    (state) => state?.userCompanyDetails?.loading
  );

  const companyServiceLoader = useSelector(
    (state) => state?.getCompanyService?.loading
  );

  const companyCityLoader = useSelector(
    (state) => state?.getCompanyCity?.loading
  );

  const carLoader = useSelector((state) => state?.userCar?.loading);

  // ---Google Data---
  const locationData = useSelector((state) => state.userAutoComplete?.userAutoComplete?.data);
  const locationDataLoader = useSelector((state) => state.userAutoComplete);
  const rateCardLoader = useSelector(
    (state) => state?.userRateCard?.loading
  );
  const countryCodeListResponse = useSelector((state) => state?.getCountryCode);
  const countryCodeListData = countryCodeListResponse?.countryCodeList?.data?.map((data) => { return { value: `+${data?.dialCode}`, label: `${data?.code}` } })

  const employeePayload = {
    companyId: companyID?.value,
    search: "",
    page: 0,
    pageSize: 10,
  };

  useEffect(() => {
    dispatch(getEmployeesList(employeePayload));
    dispatch(fetchCompanyDetails({ id: companyID?.value, type: "newBooking" }));
    dispatch(getBookingBufferTime({ type: 1 }));
    dispatch(getCountryCode());
    if (editStatus === "edit" || extensionMode) {
      dispatch(getBookingDetails(location.state?.id));
      return () => {
        dispatch(clearBookingDetails());
        // dispatch(clearRateCard());
      };
    }
  }, []);

  useEffect(() => {
    if (bookingDetails?.id && selectedCompanyDetails?.id) {
      const data = {
        contractId: selectedCompanyDetails?.Contracts?.[0]?.CompanyContracts?.ContractId,
        dutyTypeId: bookingDetails?.type,
        carType: bookingDetails?.carTypeId,
        location: details?.location
      };
      dispatch(getRateCard(data));

    }
  }, [bookingDetails]);

  useEffect(() => {
    if (bookingDetails?.sourceAddress) {
      const data = {
        name: bookingDetails?.sourceAddress,
        location: currentLat ? currentLat + "," + currentLong : "",
      };
      dispatch(getAutoComplete(data));
    }
  }, [bookingDetails]);

  useEffect(() => {
    if (overviewPolyline) {
      const decoded = polyline.decode(overviewPolyline);
      setDecodedPoints(decoded);
    }
  }, [overviewPolyline]);

  useEffect(() => {
    if (currentLocationData?.length > 0) {
      setDefaultLocation(currentLocationData[0]);
    }
  }, [currentLocationData]);

  const onHandleChange = (event, value, name) => {

    const tempDataAddress = {
      pickup: pickupAndDropAddress?.pickup || '',
      landMark: pickupAndDropAddress?.landMark || '',
      drop: pickupAndDropAddress?.drop || '',
    }
    if (name === 'pickUp' || name === "fromAirportTerminal") {
      tempDataAddress['pickup'] = value;
    }
    else if (name === "landMark") {
      tempDataAddress['landMark'] = value;
    } else if (name === 'drop' || name === 'toAirportTerminal') {
      tempDataAddress['drop'] = value;
    }

    setPickupAndDropAddress(tempDataAddress)

  };

  // ---PickUp Details---
  useEffect(() => {
    if (pickupAndDropAddress?.pickup?.place_id) {
      const data = {
        placeId: pickupAndDropAddress?.pickup?.place_id,
        type: "pickUp",
      };
      dispatch(getPlaceDetails(data));
    }
  }, [pickupAndDropAddress?.pickup?.place_id]);

  useEffect(() => {
    if (pickupAndDropAddress?.landMark?.place_id) {
      const data = {
        placeId: pickupAndDropAddress?.landMark?.place_id,
        type: "landMark",
      };
      dispatch(getPlaceDetails(data));
    }
  }, [pickupAndDropAddress?.landMark?.place_id]);

  // ---Drop Details---
  useEffect(() => {
    if (pickupAndDropAddress?.drop?.place_id) {
      const data = {
        placeId: pickupAndDropAddress?.drop?.place_id,
        type: "drop",
      };
      dispatch(getPlaceDetails(data));
    }
  }, [pickupAndDropAddress?.drop?.place_id]);

  // ---Distance---
  useEffect(() => {
    if ((pickUpLatLngData || landMarkLatLngData) && dropLatLngData) {
      const data = {
        origin: pickUpLatLngData || landMarkLatLngData,
        destination: dropLatLngData,
      };
      dispatch(getDirection(data));
    }
  }, [pickUpLatLngData, dropLatLngData, landMarkLatLngData]);

  const onInputChangeVal = debounce((event, value, formValues) => {

    const data = {
      name: value,
      cityLatitude: formValues?.location?.geoPoint?.coordinates?.[0] || "",
      cityLangitude: formValues?.location?.geoPoint?.coordinates?.[1] || "",
      location: pickupLat ? pickupLat + ',' + pickupLong : '',
      dutyType: formValues?.dutyTypeId?.tripType,
      locationType: event?.target?.name,
    };
    if (event?.type === 'change' && value) {
      dispatch(getAutoComplete(data));
    }
  }, 1000);

  const onCurrentAddress = () => {
    navigator.geolocation.getCurrentPosition(function (position) {
      setCurrentLat(position?.coords?.latitude);
      setCurrentLong(position?.coords?.longitude);
      const data = {
        latlng: position?.coords?.latitude
          ? position?.coords?.latitude + "," + position?.coords?.longitude
          : "",
      };
      dispatch(getGeocode(data));
    });
  };

  const fetchDutyType = (fieldValue) => {
    setRateCardDetails({ ...rateCardDetails, location: fieldValue?.value, locationName: fieldValue?.label });
    setPickupLat(fieldValue?.geoPoint?.coordinates?.[0] || '');
    setPickupLong(fieldValue?.geoPoint?.coordinates?.[1] || '');
    dispatch(clearAutoComplete());
    dispatch(
      getCompanyService({
        contractId: selectedCompanyDetails?.Contracts?.[0]?.id,
        location: fieldValue?.value,
      })
    );
  };

  //fetching vehicle category based on dutyType
  const fetchVehicleCategroy = (fieldValue) => {
    const vehiclePayload = {
      type: fieldValue?.tripType,
      contractId: selectedCompanyDetails?.Contracts?.[0]?.id,
      location: rateCardDetails?.location,
    };
    dispatch(getAirportTerminalList({ type: tripDutyTypeEnum?.airpotTransfer, sourceAddress: rateCardDetails?.locationName }))
    dispatch(getCar(vehiclePayload));
  };

  //fetching Ratecard based on City, dutyType, vehicle
  const fetchRateCard = (name, value) => {
    const rateCardPayload = rateCardDetails;
    rateCardPayload["contractId"] = selectedCompanyDetails?.Contracts?.[0]?.CompanyContracts?.ContractId;
    rateCardPayload[name] = value;
    setRateCardDetails(rateCardPayload);
    if (
      rateCardPayload?.contractId &&
      rateCardPayload?.dutyTypeId &&
      rateCardPayload?.vehicleCategoryId &&
      rateCardPayload?.location
    ) {
      dispatch(getRateCard(rateCardPayload));
    }
  };

  const onScrollTop = () => {
    const element = document.getElementsByClassName("appLayout");
    element[0].scroll({
      top: 0,
      behavior: "smooth",
    });
  };

  const handlePreview = (data, country) => {
    setDutyTypeLabel(data?.dutyTypeId?.label);
    const dateTime = data?.scheduledTime?.["$d"]
      ? getDateFormat(data?.scheduledTime?.["$d"], "tripTime")
      : data?.scheduledTime
        ? data?.scheduledTime
        : "";

    const calcEta = directionDataPoints?.duration?.value
      ? directionDataPoints?.duration?.value / 60 / 60
      : 0;
    const calcDistance = directionDataPoints?.distance?.text
      ? directionDataPoints?.distance?.value / 1000
      : 0;

    const airportTransferType = data?.airportRideType === "To-Airport" ? data?.toAirportTerminal : data?.fromAirportTerminal
    const airportTerminalAddress = airportTerminalOption?.filter((obj) => obj.value === airportTransferType);

    const handleAddress = (obj) => {

      let selectedAddress = {
        pickup: data?.pickUp || "",
        drop: data?.drop || ""
      }

      if (data?.dutyTypeId?.tripType === tripDutyTypeEnum.airpotTransfer) {
        if (data?.airportRideType === "To-Airport") {
          selectedAddress["drop"] = airportTerminalAddress?.[0]?.label || ""
        }
        else if (data?.airportRideType === "From-Airport") {
          selectedAddress["pickup"] = airportTerminalAddress?.[0]?.label || "";
        }
      }
      return { selectedAddress }
    }

    if (isDisabled) {
      let formData = new FormData();

      if (editStatus !== "edit" && !extensionMode) {
        const bookingFormData = {
          employeeId: data?.employeeEmail?.id || "",
          employeeName: data?.employeeName,
          employeeCountryCode: country,
          employeePhoneNumber: data?.employeePhoneNumber,
          employeeEmail: data?.travellerType === "newTraveller" || data?.travellerType === "guestTraveller" ? data?.newEmployeeEmail : data?.employeeEmail?.label,
          employeeCode: data?.employeeCode || "",
          departmentCode: data?.departmentCode || "",
          sourceAddress: handleAddress()?.selectedAddress?.pickup,
          destinationAddress: handleAddress()?.selectedAddress?.drop,
          sourceLandMarkAddress: data?.landMark || "",
          eta: calcEta || 0,
          distance: calcDistance || 0,
          location: data?.location?.value,
          branchId: data?.employeeBranchId || data?.newBranch,
          scheduledTime: dateTime,
          bookedBy: userProfile?.id,
          passengers: data?.noOfTravelers,
          isVip: data?.isVip || false,
          dutyTypeId: data?.dutyTypeId?.value,
          carTypeId: data?.vehicleCategoryId?.value,
          travelRequestNumber: data?.travelRequestNumber,
          note: data?.note,
          billingType:
            data?.billingType === "billToIndividual"
              ? 1
              : data?.billingType === "billToCompany"
                ? 2
                : "",
          companyId: companyID?.value,
          bookingType: 1,
          rateCardId: rateCard[0]?.id,
          needPlacard: data?.needPlacard || false,
          placardText: data?.placardText || ''
        };

        if (data?.pickUp || data?.fromAirportTerminal) {
          if (pickUpLatLngData?.lat && pickUpLatLngData?.lng) {
            bookingFormData['sourceLocation[0]'] = pickUpLatLngData?.lat || '';
            bookingFormData['sourceLocation[1]'] = pickUpLatLngData?.lng || '';
          }
          else {
            bookingFormData['sourceLocation'] = null;
          }

        }
        if (data?.landMark) {
          if (landMarkLatLngData?.lat && landMarkLatLngData?.lng) {
            bookingFormData['sourceLandMarkLocation[0]'] = landMarkLatLngData?.lat || '';
            bookingFormData['sourceLandMarkLocation[1]'] = landMarkLatLngData?.lng || '';
          }
          else {
            bookingFormData['sourceLandMarkLocation'] = null;
          }
        }

        //for polylines
        if (data?.drop || data?.toAirportTerminal || data?.fromAirportTerminal) {
          formData.append("destinationLocation[0]", dropLatLngData?.lat);
          formData.append("destinationLocation[1]", dropLatLngData?.lng);

          for (let i = 0; i < decodedPoints?.length; i++) {
            for (let j = 0; j < decodedPoints[i]?.length; i++) {
              formData.append(`polyLine[${i}][${j}]`, decodedPoints[i][j]);
              formData.append(
                `polyLine[${i}][${j + 1}]`,
                decodedPoints[i][j + 1]
              );
            }
          }
        }

        //For Airport Transfer
        if (
          Number(data?.dutyTypeId?.tripType) === tripDutyTypeEnum.airpotTransfer
        ) {
          formData.append("type", 4);
          formData.append("tripType", data?.airportRideType);
          formData.append("airlineDetails", data?.airlineDetails);
          formData.append("flightNo", data?.flightNo);
          formData.append('travelType', data?.airportRideType === 'To-Airport' ? 2 : data?.airportRideType === 'From-Airport' ? 1 : '')
        } else if (Number(data?.dutyTypeId?.tripType) === tripDutyTypeEnum.rental) {
          formData.append("type", 5);
          formData.append("rateCardId", data?.package);

          // Add multi-day booking data if enabled
          if (data?.multiDayBooking && data?.endDateTime) {
            const endDateTime = data?.endDateTime?.["$d"]
              ? getDateFormat(data?.endDateTime?.["$d"], "tripTime")
              : data?.endDateTime
                ? data?.endDateTime
                : "";

            formData.append("multiDay[startDate]", dateTime);
            formData.append("multiDay[endDate]", endDateTime);
          }
        } else if (
          Number(data?.dutyTypeId?.tripType) ===
          tripDutyTypeEnum.outstationRoundTrip
        ) {
          formData.append("type", 7);
          formData.append("tripType", "RoundTrip");
          formData.append(
            "tripEndTime",
            data?.returnDate?.["$d"]
              ? getDateFormat(data?.returnDate?.["$d"], "tripTime")
              : data?.returnDate
                ? data?.returnDate
                : ""
          );
        }

        if (data?.guestDetails && data?.guestDetails?.length > 0) {
          for (let i = 0; i < data?.guestDetails?.length; i++) {
            formData.append(`guestDetails[${i}][name]`, data?.guestDetails[i]?.name);
            formData.append(`guestDetails[${i}][phone]`, data?.guestDetails[i]?.phone);
            formData.append(`guestDetails[${i}][countryCode]`, data?.guestDetails[i]?.countryCode)
          }
        }

        Object.keys(bookingFormData).map((val) => {
          formData.append(val, bookingFormData[val]);
        });

        dispatch(addBooking(formData, toggle));
      } else {
        let tripId = bookingDetails?.id;
        let editData = {
          scheduledTime: dateTime,
          tripEndTime: "",
        };

        if (
          Number(data?.dutyTypeId?.tripType) ===
          tripDutyTypeEnum.outstationRoundTrip
        ) {
          editData["tripEndTime"] = data?.returnDate?.["$d"]
            ? getDateFormat(data?.returnDate?.["$d"], "tripTime")
            : data?.returnDate
              ? data?.returnDate
              : "";
        }

        dispatch(updateBooking(tripId, editData, navigate));
      }
    } else {

      //data.dutyTypeId.tripType is for new reservation and data?.dutyTypeId is for edit
      const dutyType = data?.dutyTypeId?.tripType || data?.dutyTypeId;

      const getTripPayload = {
        startTime: dateTime,
        companyId: companyID?.value,
        carTypeId: data?.vehicleCategoryId?.value || data?.vehicleCategoryId,
        sourceAddress: location?.state?.page === "edit" ? data?.pickUp?.description : handleAddress()?.selectedAddress?.pickup ? handleAddress()?.selectedAddress?.pickup : "",
        destinationAddress: location?.state?.page === "edit" ? data?.drop?.description : handleAddress()?.selectedAddress?.drop ? handleAddress()?.selectedAddress?.drop : "",
        sourceLandMarkAddress: location?.state?.page === "edit" ? data?.drop?.description : data?.landMark,
        source: (pickUpLatLngData?.lat, pickUpLatLngData?.lng) ? JSON.stringify([pickUpLatLngData?.lat, pickUpLatLngData?.lng]) : '',
        isBooking: true,
        landMark: (landMarkLatLngData?.lat && landMarkLatLngData?.lng) ? JSON.stringify([
          landMarkLatLngData?.lat,
          landMarkLatLngData?.lng,
        ]) : '',
        destination: (dropLatLngData?.lat && dropLatLngData?.lng) ? JSON.stringify([
          dropLatLngData?.lat || "",
          dropLatLngData?.lng || "",
        ]) : "",
        branchId: data?.employeeBranchId || data?.newBranch,
      };
      let payload = {
        rateCardId: rateCard[0]?.id
      };

      if (Number(dutyType) === tripDutyTypeEnum.airpotTransfer) {
        payload = {
          ...getTripPayload,
          type: tripDutyTypeEnum?.airpotTransfer,
          travelType: data?.airportRideType === 'To-Airport' ? 2 : data?.airportRideType === 'From-Airport' ? 1 : '',
          distance: calcDistance,
          eta: calcEta,
        };
      } else if (Number(dutyType) === tripDutyTypeEnum.rental) {

        let rentalEta = {};

        if (data?.drop) {
          rentalEta = {
            distance: calcDistance || details?.exactDistance,
            eta: calcEta || details?.duration,
          }
        };

        const rentalPayload = {
          ...getTripPayload,
          ...rentalEta,
          type: tripDutyTypeEnum?.rental,
          rateCardId: data?.package,
        };

        // Add multi-day booking data if enabled
        if (data?.multiDayBooking && data?.endDateTime) {
          const endDateTime = data?.endDateTime?.["$d"]
            ? getDateFormat(data?.endDateTime?.["$d"], "tripTime")
            : data?.endDateTime
              ? data?.endDateTime
              : "";

          rentalPayload.multiDay = JSON.stringify({
            startDate: dateTime,
            endDate: endDateTime,
          });
        }

        payload = rentalPayload;
      } else if (Number(dutyType) === tripDutyTypeEnum.outstationRoundTrip) {
        payload = {
          ...getTripPayload,
          tripEndTime: data?.returnDate?.["$d"]
            ? getDateFormat(data?.returnDate["$d"], "tripTime")
            : data?.returnDate
              ? data?.returnDate
              : "",
          type: tripDutyTypeEnum?.outstationRoundTrip,
          eta: calcEta || details?.duration,
          distance: calcDistance || details?.exactDistance,
        };
      }
      dispatch(getRateCalculation(payload));
      dispatch(getCarFacilities(getTripPayload?.carTypeId))
      setisDisabled(!isDisabled);
      onScrollTop();
    }
  };

  const handleBack = () => {
    if (isDisabled) {
      setisDisabled(!isDisabled);
    } else {
      navigate(-1);
    }
  };

  const defaultValues = {
    bookedByName: userProfile?.name,
    bookedByNumber: userProfile?.phoneNumber,
    bookedByEmail: userProfile?.email,
    travellerType: "existingTraveller",
    billingType:
      parseInt(selectedCompanyDetails?.Contracts?.[0]?.billingType) === 1
        ? "billToIndividual"
        : parseInt(selectedCompanyDetails?.Contracts?.[0]?.billingType) === 2
          ? "billToCompany"
          : "",
  };

  const editDefaultValues = {
    bookedByName: userProfile?.name,
    bookedByNumber: userProfile?.phoneNumber,
    bookedByEmail: userProfile?.email,
    employeeId: bookingDetails?.Employee?.id,
    employeeEmail: {
      label: bookingDetails?.Employee?.email,
      value: bookingDetails?.Employee?.email,
      id: bookingDetails?.Employee?.id,
    },
    branchId: bookingDetails?.branchId,
    employeeBranch: location.state?.branchName || 'NA',
    employeeName: bookingDetails?.Employee?.name || 'NA',
    employeePhoneNumber: bookingDetails?.Employee?.phoneNumber,
    countryCode: bookingDetails?.Employee?.countryCode || "",
    employeeCode: bookingDetails?.Employee?.employeeId || "NA",
    departmentCode: bookingDetails?.Employee?.code || "NA",
    travelRequestNumber: bookingDetails?.travelRequestNumber || "NA",
    isVip: bookingDetails?.isVip,
    noOfTravelers: details?.passengers,
    package: details?.rateCardId,
    vehicleCategoryId: {
      value: bookingDetails?.carTypeId,
      label: bookingDetails?.carType
    },
    vehicleSeater: details?.MasterCarType?.seater,
    customCarOption: [
      { value: bookingDetails?.carTypeId, label: bookingDetails?.carType },
    ],
    dutyTypeId: {
      tripType: bookingDetails?.type,
      value: bookingDetails?.type,
      label: bookingDetails?.dutyTypeName
    },
    dutyTypeOption: dutyTypeOption,
    airportRideType: details?.tripType,
    tripType: Number(bookingDetails?.type) === 7 ? 7 : 6,
    airlineDetails: details?.airlineDetails,
    location: {
      value: bookingDetails?.city,
      label: bookingDetails?.location
    },
    branch: bookingDetails?.branchId,
    flightNo: details?.flightNo,
    scheduledTime: bookingDetails?.scheduledTime,
    returnDate: details?.tripEndTime,
    note: details?.note,
    billingType:
      details?.billingType === 1
        ? "billToIndividual"
        : details?.billingType === 2
          ? "billToCompany"
          : "",
    toAirportTerminal: details?.destinationAddress,
    toAirportTerminalList: [{
      value: details?.destinationAddress,
      label: details?.destinationAddress
    }],
    fromAirportTerminal: bookingDetails?.sourceAddress,
    fromAirportTerminalList: [{
      value: bookingDetails?.sourceAddress,
      label: bookingDetails?.sourceAddress
    }],
    pickUp: {
      description: bookingDetails?.sourceAddress,
      structured_formatting: {
        main_text: bookingDetails?.sourceAddress,
        secondary_text: bookingDetails?.sourceAddress,
      },
    },
    landMark: {
      description: bookingDetails?.sourceLandMarkAddress,
      structured_formatting: {
        main_text: bookingDetails?.sourceLandMarkAddress,
        secondary_text: bookingDetails?.sourceLandMarkAddress,
      },
    },

    drop: {
      description:
        Number(bookingDetails?.type) === 7
          ? details?.tripAddress
          : details?.destinationAddress
            ? details?.destinationAddress
            : "",
      structured_formatting: {
        main_text:
          Number(bookingDetails?.type) === 7
            ? details?.tripAddress
            : details?.destinationAddress
              ? details?.destinationAddress
              : "",
        secondary_text:
          Number(bookingDetails?.type) === 7
            ? details?.tripAddress
            : details?.destinationAddress
              ? details?.destinationAddress
              : "",
      },
    },
  };

  // Extension mode default values for requesting trip extension
  const extensionDefaultValues = bookingDetails?.additionalInfo?.multiDay ? {
    bookedByName: userProfile?.name,
    bookedByNumber: userProfile?.phoneNumber,
    bookedByEmail: userProfile?.email,
    employeeId: bookingDetails?.Employee?.id,
    employeeEmail: {
      label: bookingDetails?.Employee?.email,
      value: bookingDetails?.Employee?.email,
      id: bookingDetails?.Employee?.id,
    },
    branchId: bookingDetails?.branchId,
    employeeBranch: location.state?.branchName || 'NA',
    employeeName: bookingDetails?.Employee?.name || 'NA',
    employeePhoneNumber: bookingDetails?.Employee?.phoneNumber,
    countryCode: bookingDetails?.Employee?.countryCode || "",
    employeeCode: bookingDetails?.Employee?.employeeId || "NA",
    departmentCode: bookingDetails?.Employee?.code || "NA",
    travelRequestNumber: bookingDetails?.travelRequestNumber || "NA",
    isVip: bookingDetails?.isVip,
    noOfTravelers: bookingDetails?.additionalInfo?.passengers || 1,
    package: bookingDetails?.rateConfig?.id,
    vehicleCategoryId: {
      value: bookingDetails?.carTypeId,
      label: bookingDetails?.carType
    },
    vehicleSeater: details?.MasterCarType?.seater,
    customCarOption: [
      { value: bookingDetails?.carTypeId, label: bookingDetails?.carType },
    ],
    dutyTypeId: {
      tripType: bookingDetails?.type,
      value: bookingDetails?.type,
      label: bookingDetails?.dutyTypeName
    },
    dutyTypeOption: dutyTypeOption,
    location: {
      value: bookingDetails?.city,
      label: bookingDetails?.location
    },
    branch: bookingDetails?.branchId,
    scheduledTime: bookingDetails?.scheduledTime,
    // For extension, prefill the multiDay info
    multiDayBooking: bookingDetails?.additionalInfo?.multiDay ? true : false,
    endDateTime: bookingDetails?.additionalInfo?.multiDay?.endDate,
    note: details?.note,
    billingType:
      bookingDetails?.additionalInfo?.billingType == "1"
        ? "billToIndividual"
        : bookingDetails?.additionalInfo?.billingType == "2"
          ? "billToCompany"
          : "",
    pickUp: {
      description: bookingDetails?.sourceAddress,
      structured_formatting: {
        main_text: bookingDetails?.sourceAddress,
        secondary_text: bookingDetails?.sourceAddress,
      },
    },
  } : {};

  

  //fetching search employees
  const handleAutoSuggestionSearch = debounce((event, value) => {
    if (event?.type === "change") {
      if (value) {
        dispatch(getEmployeesList({ ...employeePayload, search: value }));
      }
      else {
        dispatch(getEmployeesList(employeePayload));
      }
    }
  }, 500);

  const frontdeskDefaultValues = extensionMode ? extensionDefaultValues : (editStatus === "edit" ? editDefaultValues : defaultValues);
  const editMode = (editStatus === "edit" || extensionMode) ? bookingDetails?.id : !companyLoader;
  const customCarOption = (editStatus === "edit" || extensionMode) ? companyCarOptions : carOption;

  const handleExtension = (data, country) => {
    if (extensionMode) {

      // Parse end date for extension
      const requestedEndDate = data?.endDateTime?.["$d"]
        ? getDateFormat(data?.endDateTime?.["$d"], "tripTime")
        : data?.endDateTime
          ? data?.endDateTime
          : "";

      if (dayjs(requestedEndDate) <= dayjs(bookingDetails?.tripReturnTime)) {
        toast.error('End date must be after current end date.');
        return;
      }

      const selectedTime = dayjs(requestedEndDate).format('HH:mm');
      const startTime = dayjs(bookingDetails?.scheduledTime).format('HH:mm');

      // Check if selected time is NOT greater than start time
      if (selectedTime <= startTime) {
        toast.error('End time must be after start time for the selected end date.');
        return;
      }

      // Handle extension request for multi-day rental
      let tripId = bookingDetails?.id;
      setisDisabled(true); // Show loading state

      // Get source address (from pickUp field)
      const sourceAddress = data?.pickUp?.description || data?.pickUp || bookingDetails?.sourceAddress;

      // Get source location coordinates from pickUp lat/lng data or from the initial data
      const sourceLocation = [
        pickUpLatLngData?.lat || bookingDetails?.sourceLocation?.coordinates?.[0] || "",
        pickUpLatLngData?.lng || bookingDetails?.sourceLocation?.coordinates?.[1] || ""
      ];

      // Create extension request payload with only changed fields
      const extensionData = {
        sourceAddress: sourceAddress,
        sourceLocation: sourceLocation,
        requestedEndDate: requestedEndDate
      };

      // Call the extension request API directly
      requestExtensionService({
        tripId: tripId,
        extensionData: extensionData
      }).then((response) => {
        
        setisDisabled(false);
        if (response?.success) {
          // Success - show confirmation toast and navigate
          toast.success(response?.message);
          setTimeout(() => {
            navigate('/front-desk/all', { replace: true });
          }, 2000);
        } else {
          // Error handling
          toast.error(response?.message || "Failed to request extension");
        }
      }).catch((error) => {
        setisDisabled(false);
        toast.error("Extension request error. Please try again.");
      });
    }
  }

  return (
    <Grid container justifyContent={"center"} className="br20 mb20">
      <Grid item xs={12} lg={11} className="bgLightWhite mtb20 plr20">
        <Box className="justifyBetween">
          <Box className="justifyStart pt20">
            <KeyboardArrowLeftRoundedIcon
              className="colorGrey font36"
              role="presentation"
              onClick={handleBack}
            />
          </Box>
          <Box className="justifyEnd">
            {isDisabled && (
              <CommonButton
                name="Edit"
                btnClass={"btnMd"}
                iconType={"edit"}
                iconPlace={"front"}
                onClick={() => setisDisabled(!isDisabled)}
              />
            )}
          </Box>
        </Box>
        {userProfile?.id && <CommonMultiForm
          formData={bookingByForm}
          button={""}
          defaultValues={defaultValues}
        />}
        {!companyLoader &&
          userProfile?.id &&
          frontdeskDefaultValues &&
          editMode ? (
          <CommonMultiForm
            formData={bookingForm(
              dutyTypeOption,
              customCarOption,
              companyEmployeelist,
              selectedCompanyDetails,
              location?.state?.page,
              cityOption,
              userProfile,
              role,
              employeelist,
              bookingDetails?.Employee?.employeeId,
              extensionMode
            )}
            editType={location?.state?.page === "edit"}
            extensionMode={extensionMode}
            cityOption={cityOption}
            branchOption={branchOption}
            onSubmittBtn={extensionMode ? handleExtension : handlePreview}
            button={extensionMode ? (isDisabled ? "Confirm" : "Request Extension") : (!isDisabled ? "Preview & Confirm" : "Confirm")}
            disabled={isDisabled}
            userProfile={userProfile}
            employeeList={employeeList}
            defaultValues={frontdeskDefaultValues}
            rateCardPackage={rateCardPackage}
            onInputChangeVal={onInputChangeVal}
            locationData={locationData?.predictions || locationData?.results || []}
            dutyTypeOption={dutyTypeOption}
            carOption={carOption}
            fetchVehicleCategroy={fetchVehicleCategroy}
            fetchRateCard={fetchRateCard}
            onCurrentAddress={onCurrentAddress}
            currentLat={currentLat}
            currentLong={currentLong}
            companyEmployeelist={role === '3' ? employeelist : companyEmployeelist}
            defaultAddress={
              defaultLocation?.formatted_address
                ? defaultLocation?.formatted_address
                : {}
            }
            bookingBufferTime={bookingBufferTime}
            onHandleChange={onHandleChange}
            fareBreakup={isDisabled}
            dutyTypeLabel={dutyTypeLabel}
            fetchDutyType={fetchDutyType}
            handleAutoSuggestionSearch={handleAutoSuggestionSearch}
            airportTerminalOption={airportTerminalOption}
            pageName={'reservation'}
            dutyTypeIdLoader={{ fieldType: "dutyTypeId", loader: companyServiceLoader }}
            locationLoader={{ fieldType: "location", loader: companyCityLoader }}
            vehicleCategoryIdLoader={{ fieldType: "vehicleCategoryId", loader: carLoader }}
            packageLoader={{ fieldType: "package", loader: rateCardLoader }}
            pickUpLoader={{ fieldType: locationDataLoader?.fieldTypeLoader, loader: locationDataLoader?.loading }}
            landMarkLoader={{ fieldType: locationDataLoader?.fieldTypeLoader, loader: locationDataLoader?.loading }}
            dropLoader={{ fieldType: locationDataLoader?.fieldTypeLoader, loader: locationDataLoader?.loading }}
            countryCodeListData={countryCodeListData}
            tripDetails={extensionMode ? bookingDetails : null}
          />
        ) : (
          <Loader />
        )}
      </Grid>
      <ConfirmModal open={open} toggle={toggle} navigate={navigate} pageName={"reservation"} />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Grid>
  );
};

export default FrontDeskNewBooking;